import React from "react";

import { useIntl } from "react-intl";

import { Link } from "ds/Button";

import * as S from "./IntegrationScopesText.styles";

type IntegrationScopesTextProps = {
  type: string;
  link: string;
};

const IntegrationScopesText = ({ type, link }: IntegrationScopesTextProps) => {
  const intl = useIntl();

  const getIntlKey = (key: string) => {
    const fullKey = `integration.configure.${type}.${key}`;
    return intl.messages[fullKey] !== undefined
      ? fullKey
      : `integration.configure.${key}`;
  };

  const subIntroKey = getIntlKey("sub_intro");
  const hasSubIntroText = intl.messages[subIntroKey] !== undefined;

  const scopeKey = getIntlKey("scopes");
  const hasEnsureScopeText = intl.messages[scopeKey] !== undefined;

  return (
    <div>
      {hasSubIntroText && (
        <p>
          {intl.formatMessage(
            {
              id: subIntroKey
            },
            {
              a: chunks => (
                <Link href={link} analyticId={link}>
                  {chunks}
                </Link>
              )
            }
          )}
        </p>
      )}
      {hasEnsureScopeText && (
        <>
          <S.TitleScopesText>
            {intl.formatMessage(
              {
                id: getIntlKey("ensure_scopes"),
                defaultMessage: "Ensure Scopes"
              },
              {
                b: chunks => <b>{chunks}</b>
              }
            )}
          </S.TitleScopesText>

          <S.ScopesText>
            {intl.formatMessage(
              {
                id: scopeKey,
                defaultMessage: "Scopes"
              },
              {
                br: <br />,
                code: chunks => <S.Code variant="inline">{chunks}</S.Code>
              }
            )}
          </S.ScopesText>
        </>
      )}
    </div>
  );
};

export default IntegrationScopesText;
